import { useCallback, useRef } from "react";

/**
 * Returns a runner that ignores calls while a previous one is still in
 * flight.
 *
 * A `loading` flag in state is not enough to stop a double tap: both taps are
 * handled before React re-renders the button as disabled, so both send a
 * request. A ref is updated synchronously, so the second tap sees it.
 */
export const useInFlightGuard = () => {
  const inFlight = useRef(false);
  return useCallback(<T>(fn: () => Promise<T>) => {
    if (inFlight.current) {
      return;
    }
    inFlight.current = true;
    return fn().finally(() => {
      inFlight.current = false;
    });
  }, []);
};
